export const flattenSubLessons = <L extends { sub_lessons?: L[] }>(lesson: L): L[] => {
    const result: L[] = [];

    const recursiveFlatten = (currentLesson: L) => {
        result.push(currentLesson);

        if (Array.isArray(currentLesson.sub_lessons)) {
            for (const subLesson of currentLesson.sub_lessons) {
                recursiveFlatten(subLesson);
            }
        }
    };

    recursiveFlatten(lesson);

    return result;
};
